// app/javascript/controllers/textarea_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (this.element.tagName === 'TEXTAREA') {
      this.setupAutoExpand(this.element)
    }
  }

  setupAutoExpand(textarea) {
    // Désactiver le redimensionnement manuel
    textarea.style.resize = 'none'

    // Fonction d'auto-expansion
    const autoExpand = () => {
      textarea.style.height = '4'
      textarea.style.height = textarea.scrollHeight + 'px'
    }

    // Lier la fonction au contexte
    this.boundAutoExpand = autoExpand.bind(this)

    // Ajouter l'écouteur
    textarea.addEventListener('input', this.boundAutoExpand)

    // Expansion initiale
    this.boundAutoExpand()
  }

  disconnect() {
    if (this.element && this.boundAutoExpand) {
      this.element.removeEventListener('input', this.boundAutoExpand)
    }
  }
}